
import React from "react";

interface AboutSectionProps {
  longDescription: string;
  yearEstablished: number;
  attributes: { icon: string; label: string }[];
}

export default function AboutSection({
  longDescription,
  yearEstablished,
  attributes,
}: AboutSectionProps) {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-6 shadow-sm">
      <h3 className="text-lg font-bold text-gray-900 mb-4">
        About This Business
      </h3>
      <p className="text-sm text-gray-700 leading-relaxed mb-5">
        {longDescription}
      </p>

      <div className="flex items-center gap-2 text-sm text-gray-500 mb-5 pb-5 border-b border-gray-100">
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-calendar-line text-teal-500"></i>
        </div>
        <span>
          Serving Roseville since{" "}
          <strong className="text-gray-700">{yearEstablished}</strong>
        </span>
      </div>

      <h4 className="text-sm font-bold text-gray-900 mb-3">
        Amenities &amp; Features
      </h4>
      <div className="flex flex-wrap gap-2">
        {attributes.map((attr, idx) => (
          <span
            key={idx}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-gray-50 text-gray-700 text-xs font-medium rounded-full border border-gray-100"
          >
            <i className={`${attr.icon} text-teal-500 text-sm`}></i>
            {attr.label}
          </span>
        ))}
      </div>
    </div>
  );
}
